export default class CompleteProfileService {
  static hasToCompleteProfile({ affInfos }) {
    let hasToCompleteProfile = true;
    if (affInfos) {
      hasToCompleteProfile = !affInfos.address1 || !affInfos.city || !affInfos.country || !affInfos.zipcode;
    }
    return hasToCompleteProfile;
  }
}
